import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './technician-navigation.scss';

export const TechnicianNavigation: React.FC = () => {
  const { userRole, logout } = useAuth();

  if (!userRole) {
    return null;
  }

  return (
    <div className="technician-navigation">
      {/* <div className="nav-info">
        <span>Logged in as: {userRole.email} ({userRole.role})</span>
      </div> */}
      <div className="nav-actions">
        {userRole.role === 'admin' && (
          <a href="/admin" className="admin-link">Admin Dashboard</a>
        )}
        <button onClick={logout} className="logout-btn">Logout</button>
      </div>
    </div>
  );
}; 